import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import TimerView from "../views/TimerView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: TimerView,
  },
  {
    path: "/pair",
    name: "pair",
    // route level code-splitting
    // this generates a separate chunk (controller.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "controller" */ "../views/ControllerView.vue"
      ),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
